import { collection, DocumentData } from 'firebase/firestore'
import { useAuthState } from 'react-firebase-hooks/auth'
import { useCollectionData } from 'react-firebase-hooks/firestore'
import { Data } from 'react-firebase-hooks/firestore/dist/firestore/types'
import { firebaseAuth, firestore } from '../config/firebase'
import { USERS_COLLECTION } from './useUserData'

export const SESSIONS_SUBCOLLECTION = 'sessions'

/**
 * Returns firestore session data for the authenticated user.
 *
 * Returns `undefined` if no user has been authenticated or if the data is still
 * being fetched.
 *
 * Returns an empty array if the data has been fetched, but the user has no
 * session data.
 *
 * Will trigger re-renders everytime the data gets updated via firestore's
 * `onSnapshot` method.
 */
export const useUserSessions = (): Data<DocumentData, '', ''>[] => {
  const [user] = useAuthState(firebaseAuth)

  const sessionsCollectionRef = user
    ? collection(firestore, USERS_COLLECTION, user.uid, SESSIONS_SUBCOLLECTION)
    : undefined

  const [userSessionsData] = useCollectionData(sessionsCollectionRef)
  return userSessionsData
}
